import React from "react";

import styled, { css } from "styled-components";

import { TEXT_VARIANTS } from "components/atoms/text/typography";

const applyVariant = ({ $variant }) => {
    const styles = TEXT_VARIANTS[$variant];

    if (!styles) {
        return "";
    }

    return css`
        font-size: ${styles.fontSize};
        line-height: ${styles.lineHeight};
        font-weight: ${styles.fontWeight};
        ${styles.letterSpacing ? `letter-spacing: ${styles.letterSpacing};` : ""}
        ${styles.wordBreak ? `word-break: ${styles.wordBreak};` : ""}
    `;
};

const TextBase = styled.div`
    ${({ $display }) => $display && `display: ${$display};`}
    margin: ${({ $margin }) => $margin || "0"};
    ${({ $width }) => $width !== undefined && $width !== null && `width: ${$width};`}
    ${({ $height }) => $height !== undefined && $height !== null && `height: ${$height};`}
    color: ${({ $color }) => $color || "inherit"};
    ${({ $textAlign }) => $textAlign && `text-align: ${$textAlign};`}
    ${({ $transition }) => $transition && `transition: ${$transition};`}
    ${({ $whiteSpace }) => $whiteSpace && `white-space: ${$whiteSpace};`}

    line-height: 1.4;
    ${applyVariant}

    ${({ $fontSize }) => $fontSize && `font-size: ${$fontSize};`}
    ${({ $fontWeight }) => $fontWeight && `font-weight: ${$fontWeight};`}
    ${({ $lineHeight }) => $lineHeight && `line-height: ${$lineHeight};`}
    ${({ $letterSpacing }) => $letterSpacing && `letter-spacing: ${$letterSpacing};`}
    ${({ $wordBreak }) => $wordBreak && `word-break: ${$wordBreak};`}

    ${({ $ellipsis }) =>
        $ellipsis &&
        css`
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        `}

    ${({ $lines }) =>
        $lines &&
        css`
            overflow: hidden;
            display: -webkit-box;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: ${$lines};
            -webkit-box-orient: vertical;
        `}

    ${({ $botTextType }) =>
        $botTextType &&
        css`
            white-space: pre-wrap;
            text-align: justify;
            word-break: break-all;
            list-style: disc;
        `}

    ${({ $withBarType }) =>
        $withBarType &&
        css`
            padding-left: 8px;
            border-left: 2px solid var(--color-TitleBar);
        `}
`;

const Text = React.forwardRef(function Text(props, ref) {
    const {
        display,
        margin,
        width,
        height,
        color,
        textAlign,
        transition,
        whiteSpace,
        variant,
        fontSize,
        fontWeight,
        lineHeight,
        letterSpacing,
        wordBreak,
        ellipsis,
        lines,
        botTextType,
        withBarType,
        ...restProps
    } = props;

    return (
        <TextBase
            ref={ref}
            {...restProps}
            $display={display}
            $margin={margin}
            $width={width}
            $height={height}
            $color={color}
            $textAlign={textAlign}
            $transition={transition}
            $whiteSpace={whiteSpace}
            $variant={variant}
            $fontSize={fontSize}
            $fontWeight={fontWeight}
            $lineHeight={lineHeight}
            $letterSpacing={letterSpacing}
            $wordBreak={wordBreak}
            $ellipsis={ellipsis}
            $lines={lines}
            $botTextType={botTextType}
            $withBarType={withBarType}
        />
    );
});

export default Text;
